import { IMinPrice } from '~/src/entities/tariff-lines';

export const getFinalPriceFromMinPrices = (minPrices: IMinPrice[] = [], isVillage: boolean): number => {
    const filteredPrices = minPrices.filter(item => item.is_cottage === Number(isVillage));

    if (filteredPrices.length) {
        return filteredPrices.length > 1
            ? filteredPrices[filteredPrices.length - 1]?.price_final
            : filteredPrices[0]?.price_final;
    }

    return 0;
};
